module.exports = __webpack_public_path__ + "img/kreuzchen.55b1f912.png";